import Switcher from '../control/Switcher'
import InputAddon from '../control/InputAddon'

const QuickLinksSettings = (props) => <div className={'form-group row'}>
  <div className={'col-md-3 qa-quicklinks-visibility'}>
    <div className={'quick_links_common_settings_title'}>Visibility</div>
    <Switcher on={props.settings.enableQuickLinks} onChange={() => props.onChange({ enableQuickLinks: !props.settings.enableQuickLinks })} label={'Show quick links'} />
  </div>
  <div className={'col-md-3 qa-quicklinks-border-radius'}>
    <div className={'quick_links_common_settings_title'}>Border radius</div>
    <InputAddon type={'number'} addon={'px'} value={props.settings.borderRadius} min={0} onChange={(val) => props.onChange({ borderRadius: parseInt(val, 10) })} />
  </div>
  <div className={'col-md-3 qa-quicklinks-border'}>
    <div className={'quick_links_common_settings_title'}>Border</div>
    <Switcher on={props.settings.enableBorder} onChange={() => props.onChange({ enableBorder: !props.settings.enableBorder })} />
  </div>
</div>

export default QuickLinksSettings
